export class VesselAgeFilterValueConverter {
    toView(age:string) {
        if(age){
            const ageYear = Number(age.toString().split(".")[0]);
            const currentYear = Number(new Date().getFullYear() -1); 

            if (!age || ageYear == currentYear ) 
                return "N/A";

            if(age.toString().includes("y/o"))
                return age;

            return age + ' y/o';
        }
    }
}
